import { topojson } from "chartjs-chart-geo";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Chart } from "react-chartjs-2";
import styled from "styled-components";
import { CenteredFlex } from "../../../../../components/layout";
import { Spinner } from "../../../../../components/loader/icon";
import {
  countries,
  reverseCountries,
} from "../../../../../store/common/models";
import { ConfigContext } from "../../config-context";

const Canvas = styled.canvas<{ loaded?: boolean }>`
  max-width: 100%;
  height: ${(props) => (props.loaded ? "100%" : "0")};
`;

const Wrapper = styled.div`
  ${CenteredFlex}
  height: 20em;
`;

const WorldMap: React.FunctionComponent<{}> = () => {
  const [worldData, setWorldData] = useState<any>();
  const [loaded, setLoaded] = useState<boolean>(false);
  const { config } = useContext(ConfigContext);

  const container = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    fetch("https://unpkg.com/world-atlas/countries-50m.json")
      .then((r) => r.json())
      .then((data) => {
        setWorldData(
          (topojson.feature(data, data.objects.countries) as any).features
        );
      });
  }, []);

  const context = useMemo(() => container.current?.getContext("2d"), [
    container.current,
  ]);

  useEffect(() => {
    if (worldData && context && !loaded) {
      new Chart(context, {
        type: "choropleth",
        data: {
          labels: worldData.map((d: any) => d.properties.name),
          datasets: [
            {
              label: "Countries",
              data: worldData.map((d: any) => {
                const countryName = d.properties.name;

                // Try find country
                const code =
                  reverseCountries[
                    countryName as typeof countries["values"][number]
                  ];

                // If it ir prohibited give 1 value
                const value =
                  code &&
                  config.configuration.prohibitedCountries.includes(code)
                    ? 1
                    : 0;

                return {
                  feature: d,
                  value,
                };
              }),
            },
          ],
        },
        options: {
          showOutline: true,
          showGraticule: true,

          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              callbacks: {
                label: function (context: any) {
                  return (
                    context?.dataset?.data[context.dataIndex].feature.properties
                      .name || ""
                  );
                },
              },
            },
          },
          scales: {
            xy: {
              projection: "equalEarth",
              display: false,
            },
            color: {
              display: false,
            },
          },
        },
      });

      setLoaded(true);
    }
  }, [worldData, context, loaded]);

  return (
    <Wrapper>
      <Canvas ref={container} loaded={loaded}></Canvas>
      {loaded ? null : <Spinner />}
    </Wrapper>
  );
};

export default WorldMap;
